module.exports = __webpack_public_path__ + "img/download.64b7374e.svg";